import { TsDOM as q } from '@/scripts/core/TsDOM'
import { UcoastEl } from '@/scripts/core/UcoastEl'

export class DetailsModal extends UcoastEl {
	static htmlSelector = 'details-modal'
	static searchCloseAnimationFallbackMs = 380
	detailsContainer: HTMLDetailsElement
	summaryToggle: HTMLElement
	button: HTMLButtonElement
	onBodyClickEvent?: (event: MouseEvent) => undefined
	constructor() {
		super()
		this.detailsContainer = q.rs('details', this)
		this.summaryToggle = q.rs('summary', this)
		this.button = q.rs('button[type="button"]', this)

		this.detailsContainer.addEventListener(
			'keyup',
			(event) => event.code?.toUpperCase() === 'ESCAPE' && this.close()
		)
		this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this))
		this.button.addEventListener('click', this.close.bind(this))

		this.summaryToggle.setAttribute('role', 'button')
	}

	isOpen() {
		return this.detailsContainer.hasAttribute('open')
	}

	onSummaryClick(event: MouseEvent) {
		event.preventDefault()
		const closestDetails = q.oClosestTarget(event, 'details')
		closestDetails?.hasAttribute('open')
			? this.close()
			: this.open({
					target: q.rt(event),
			  })
	}

	onBodyClick(event: MouseEvent) {
		const target = q.rt(event)
		if (!this.contains(target) || target.classList.contains('modal-overlay')) this.close(false)
	}

	open(event: { target: HTMLElement }) {
		this.detailsContainer.removeAttribute('data-uc-closing')
		this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this)
		if (!this.onBodyClickEvent) throw new Error('onBodyClickEvent is undefined')
		const closestDetails = q.oc(event.target, 'details')
		if (closestDetails) {
			closestDetails.setAttribute('open', 'true')
		}

		document.body.addEventListener('click', this.onBodyClickEvent)
		document.body.classList.add('overflow-hidden')
		if(this.classList.contains('header__search')) document.querySelector('.section-header')?.setAttribute('data-uc-header-search-open', '')

		window.TsDOM.trapFocus(
			q.rs('[tabindex="-1"]', this.detailsContainer),
			q.os('input:not([type="hidden"])', this.detailsContainer)
		)
	}

	finalizeClose(focusToggle = true, removeTrapFocus = true) {
		if (removeTrapFocus) {
			window.TsDOM.removeTrapFocus(focusToggle ? this.summaryToggle : undefined)
		}
		this.detailsContainer.removeAttribute('data-uc-closing')
		this.detailsContainer.removeAttribute('open')
		if (this.onBodyClickEvent) {
			document.body.removeEventListener('click', this.onBodyClickEvent)
		}

		document.body.classList.remove('overflow-hidden')
		if(this.classList.contains('header__search')) document.querySelector('.section-header')?.removeAttribute('data-uc-header-search-open')
	}

	closeWithSearchAnimation(focusToggle = true) {
		window.TsDOM.removeTrapFocus(focusToggle ? this.summaryToggle : undefined)
		this.detailsContainer.setAttribute('data-uc-closing', '')

		const searchForm = q.os('.search-modal__form', this.detailsContainer)
		let isClosed = false
		const finalize = () => {
			if (isClosed) return
			isClosed = true
			this.finalizeClose(false, false)
		}

		searchForm?.addEventListener(
			'transitionend',
			(event) => {
				if (event.target !== searchForm) return
				if (event.propertyName !== 'transform') return
				finalize()
			},
			{ once: true }
		)
		window.setTimeout(finalize, DetailsModal.searchCloseAnimationFallbackMs)
	}

	close(focusToggle = true) {
		if (this.classList.contains('header__search')) {
			if (this.detailsContainer.hasAttribute('data-uc-closing')) return
			if (this.detailsContainer.hasAttribute('open')) {
				this.closeWithSearchAnimation(focusToggle)
				return
			}
		}

		this.finalizeClose(focusToggle)
	}
}

customElements.define('details-modal', DetailsModal)
